// extracted by mini-css-extract-plugin
module.exports = {"container":"TaskLogTable-module__container__cxc54","small":"TaskLogTable-module__small__3XSoJ"};